import { ConfirmAppointmentReminderOptions } from '../enums/reminder_enum';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

export interface IConfirmAppointmentReminderOptions {
  isSendEmail: boolean;
  isSendTextMessage: boolean;
  isSendEmailReminderEnabled: boolean;
  isSendTextMessageReminderEnabled: boolean;
}

export interface IConfirmAppointmentReminderValues {
  isSendReminder: boolean;
  isReminderOptionEnable: boolean;
}

export class ConfirmAppointmentModel {
  private _confirmAppointmentReminderOptions: IConfirmAppointmentReminderOptions;
  private _comments: string = '';
  private _phoneNumber: string = '';

  constructor(private ngAppointmentReasonUsersource: TAppointmentReasonUsersource) {
    this._initialize();
  }

  saveSendEmail(value: boolean): void {
    this._confirmAppointmentReminderOptions.isSendEmail = value;
  }
  saveSendTextMessage(value: boolean): void {
    this._confirmAppointmentReminderOptions.isSendTextMessage = value;
  }
  saveComments(comments: string): void {
    this._comments = comments;
  }
  savePhoneNumber(phoneNumber: string) {
    this._phoneNumber = phoneNumber;
  }

  get Comments(): string {
    return this._comments;
  }

  get phoneNumber(): string {
    return this._phoneNumber;
  }

  get confirmAppointmentReminderOptions(): IConfirmAppointmentReminderOptions {
    return this._confirmAppointmentReminderOptions;
  }

  private _initialize(): void {
    const { isSendReminder: isSendEmail, isReminderOptionEnable: isSendEmailReminderEnabled } =
      this._initializeConfirmAppointmentReminderValues(
        this.ngAppointmentReasonUsersource.read().selectedType.send_email_reminder
      );
    const { isSendReminder: isSendTextMessage, isReminderOptionEnable: isSendTextMessageReminderEnabled } =
      this._initializeConfirmAppointmentReminderValues(
        this.ngAppointmentReasonUsersource.read().selectedType.send_sms_reminder
      );
    this._confirmAppointmentReminderOptions = {
      isSendEmail,
      isSendEmailReminderEnabled,
      isSendTextMessage,
      isSendTextMessageReminderEnabled
    };
    this._comments = '';
  }

  initializeConfirmAppointmentReminderOptions(): void {
    this._initialize();
  }

  private _initializeConfirmAppointmentReminderValues(reminderChoice: string): IConfirmAppointmentReminderValues {
    let isSendReminder: boolean = false;
    let isReminderOptionEnable: boolean = true;
    switch (reminderChoice) {
      case ConfirmAppointmentReminderOptions.ON:
        isSendReminder = true;
        isReminderOptionEnable = true;
        break;
      case ConfirmAppointmentReminderOptions.DISABLED:
        isSendReminder = false;
        isReminderOptionEnable = false;
        break;
      case ConfirmAppointmentReminderOptions.ENABLED:
        isSendReminder = true;
        isReminderOptionEnable = false;
        break;
      default:
        isSendReminder = false;
        isReminderOptionEnable = true;
    }
    return { isSendReminder, isReminderOptionEnable };
  }
}

angular.module('capability-ng-appointments').service('ngConfirmAppointmentModel', ConfirmAppointmentModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/models/confirm_appointment_model.ts